import { IProductData } from "common/records/Product";
import { ActionsUnion, createAction } from "common/reducers/UtilsTypes";
import { List } from "immutable";

export interface options {
  model?: string;
  pushToList?: boolean;
}

export type DocumentKind = "image" | "document";

export const FETCH_PRODUCT = "@product/FETCH_PRODUCT";
export const RECEIVE_PRODUCT = "@product/RECEIVE_PRODUCT";
export const RECEIVE_PRODUCT_OVERVIEWS = "@product/RECEIVE_PRODUCT_OVERVIEWS";
export const RECEIVE_PRODUCT_OVERVIEW = "@product/RECEIVE_PRODUCT_OVERVIEW";
export const RESET_PRODUCT = "@product/RESET_PRODUCT";
export const REMOVE_PRODUCT = "@product/REMOVE_PRODUCT";
export const SET_PRODUCT_LOADED = "@product/SET_PRODUCT_LOADED";
export const RECEIVE_PRODUCT_DOCUMENTS = "@product/RECEIVE_PRODUCT_DOCUMENTS";
export const DESTROY_PRODUCT_DOCUMENT = "@product/DESTROY_PRODUCT_DOCUMENT";
export const RECEIVE_PRODUCT_IMAGES = "@product/RECEIVE_PRODUCT_IMAGES";
export const DESTROY_PRODUCT_IMAGE = "@product/DESTROY_PRODUCT_IMAGE";
export const FETCH_PRODUCT_IDS_MODEL = "@product/FETCH_PRODUCT_IDS_MODEL";
export const ADD_DOCUMENT_TO_PRODUCT = "@product/ADD_DOCUMENT_TO_PRODUCT";
export const PRODUCT_DOCUMENT_SORT = "@product/PRODUCT_DOCUMENT_SORT";
export const PRODUCT_DOCUMENT_DELETE = "@product/PRODUCT_DOCUMENT_DELETE";
export const SET_PRODUCT_LEAF = "@product/SET_PRODUCT_LEAF";

export const ProductActions = {
  fetchProduct: (productId: number) => createAction(FETCH_PRODUCT, { productId }),
  receiveProduct: (product: IProductData, options: options = {}) => createAction(RECEIVE_PRODUCT, { product, options }),
  receiveProductOverviews: (products: IProductData[]) => createAction(RECEIVE_PRODUCT_OVERVIEWS, { products }),
  receiveProductOverview: (productOverview: IProductData) =>
    createAction(RECEIVE_PRODUCT_OVERVIEW, { productOverview }),
  resetProduct: (productId: string | number) => createAction(RESET_PRODUCT, { productId }),
  removeProduct: (productId: number) => createAction(REMOVE_PRODUCT, { productId }),
  setProductLoaded: (productId: number) => createAction(SET_PRODUCT_LOADED, { productId }),
  receiveProductDocuments: (productId: number, documentIds: List<number>) =>
    createAction(RECEIVE_PRODUCT_DOCUMENTS, { productId, documentIds }),
  destroyProductDocument: (documentId: number) => createAction(DESTROY_PRODUCT_DOCUMENT, { documentId }),
  receiveProductImages: (productId: number, imageIds: List<number>) =>
    createAction(RECEIVE_PRODUCT_IMAGES, { productId, imageIds }),
  destroyProductImage: (imageId: number) => createAction(DESTROY_PRODUCT_IMAGE, { imageId }),
  addDocumentToProduct: (productId: number, files: File[], kind: DocumentKind) =>
    createAction(ADD_DOCUMENT_TO_PRODUCT, { productId, files, kind }),
  productDocumentSort: (productId: number, oldIndex: number, newIndex: number, kind: DocumentKind) =>
    createAction(PRODUCT_DOCUMENT_SORT, { productId, oldIndex, newIndex, kind }),
  productDocumentDelete: (productId: number, documentId: number, kind: DocumentKind) =>
    createAction(PRODUCT_DOCUMENT_DELETE, { productId, documentId, kind }),
  setProductLeaf: (productId: number, leaf: boolean) => createAction(SET_PRODUCT_LEAF, { productId, leaf }),
};

export type ProductActions = ActionsUnion<typeof ProductActions>;
